module.exports = __webpack_public_path__ + "img/logo.8eae913c.svg";